import { useSelector } from 'react-redux'
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap'
import { CheckCircle, ArrowRight } from 'react-feather'
import { useNavigate } from 'react-router-dom'
import { URL_INVENTORY } from 'utils/pathUrl'

/**
 * ModalSuccessGroupMapping
 * Modal popup konfirmasi setelah Pemetaan Sekaligus berhasil dibuat.
 * Memberikan opsi untuk langsung membuka grup inventori atau tetap di halaman pemetaan.
 */
const ModalSuccessGroupMapping = ({
  isOpen,
  toggle,
  groupData,
  warehouse,
  onStay,
}) => {
  const navigate = useNavigate()
  const { warehouses } = useSelector((s) => s?.manageStock || {})

  if (!isOpen) return null

  const groupId = groupData?.id
  const groupLabel = groupData?.label || 'Grup Baru'
  const activeWh = warehouse || groupData?.warehouse

  const handleNavigateGroup = () => {
    if (activeWh?.id || activeWh?.name) {
      try {
        const masterList = warehouses?.newData || []
        const matched = masterList.find(
          (w) =>
            (activeWh.id && String(w.id) === String(activeWh.id)) ||
            (activeWh.name &&
              w.name &&
              w.name.trim().toLowerCase() ===
                activeWh.name.trim().toLowerCase()),
        )

        const whObj = matched || {
          id: Number(activeWh.id) || activeWh.id,
          name: activeWh.name || '',
          label: activeWh.name || '',
          value: Number(activeWh.id) || activeWh.id,
        }

        localStorage.setItem(
          'defaultWarehouseInventory',
          JSON.stringify(whObj),
        )
      } catch (err) {
        console.error('Failed to set warehouse in localStorage:', err)
      }
    }

    if (groupId) {
      try {
        localStorage.setItem(
          'breadcrumbs',
          JSON.stringify([{ id: groupId, label: groupLabel }]),
        )
      } catch (err) {
        console.error('Failed to set breadcrumb in localStorage:', err)
      }

      navigate(`${URL_INVENTORY}/${groupId}`, {
        state: {
          label: groupLabel,
        },
      })
    } else {
      navigate(URL_INVENTORY)
    }

    if (toggle) toggle()
  }

  const handleStay = () => {
    if (onStay) {
      onStay()
    } else if (toggle) {
      toggle()
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      autoFocus={false}
      style={{ maxWidth: '480px' }}
      className="modal-dialog-centered"
      data-testid="modal-success-group-mapping"
    >
      <ModalHeader
        toggle={toggle}
        className="border-bottom-0 pb-0 pt-3 px-3 px-md-4"
      >
        <div className="d-flex align-items-center gap-3">
          <div
            className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
            style={{
              width: '44px',
              height: '44px',
              backgroundColor: '#ecfdf3',
              border: '1px solid #d1fadf',
            }}
          >
            <CheckCircle size={24} color="#027a48" />
          </div>
          <div>
            <h5
              className="modal-title fw-bold text-dark mb-0"
              style={{ fontSize: '1.05rem' }}
            >
              Pemetaan Sekaligus Berhasil
            </h5>
            <span className="text-muted" style={{ fontSize: '0.78rem' }}>
              Grup inventori berhasil dibuat
            </span>
          </div>
        </div>
      </ModalHeader>

      <ModalBody className="px-3 px-md-4 py-3">
        <div
          className="p-3 rounded-3 mb-2"
          style={{
            backgroundColor: '#f8fafc',
            border: '1px solid #e2e8f0',
          }}
        >
          <div className="d-flex flex-column gap-1">
            <span style={{ fontSize: '0.75rem', color: '#64748b' }}>
              NAMA / IDENTIFIKASI GRUP:
            </span>
            <span
              className="fw-bold text-dark"
              style={{ fontSize: '0.95rem' }}
            >
              {groupLabel}
            </span>
          </div>
        </div>

        <p
          className="text-muted mb-0 mt-2"
          style={{ fontSize: '0.85rem', lineHeight: '1.5' }}
        >
          Proses pemetaan inventori telah tersimpan. Apakah Anda ingin langsung
          membuka grup inventori ini atau tetap berada di halaman pemetaan?
        </p>
      </ModalBody>

      <ModalFooter className="border-top-0 pt-0 pb-3 px-3 px-md-4 d-flex justify-content-end gap-2">
        <Button
          color="secondary"
          outline
          onClick={handleStay}
          data-testid="modal-success-group-stay-button"
          style={{
            borderRadius: '8px',
            height: '40px',
            fontSize: '0.875rem',
            fontWeight: '600',
          }}
        >
          Tetap di Halaman Ini
        </Button>
        <Button
          color="primary"
          onClick={handleNavigateGroup}
          data-testid="modal-success-group-navigate-button"
          className="d-flex align-items-center gap-1"
          style={{
            borderRadius: '8px',
            height: '40px',
            fontSize: '0.875rem',
            fontWeight: '600',
          }}
        >
          <span>Buka Grup Inventori</span>
          <ArrowRight size={16} />
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ModalSuccessGroupMapping
